import React, { useState, useEffect, FC } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

interface LoadingPopupProps {
  open: boolean;
}

const LoadingPopup: FC<LoadingPopupProps> = ({ open }) => {
  const [progress, setProgress] = useState<number>(0);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (open) {
      setProgress(0); 
      timer = setInterval(() => {
        setProgress((prevProgress: number) => (prevProgress < 130 ? prevProgress + 1 : 130));
      }, 130);  
    }

    return () => {
      clearInterval(timer);
    };
  }, [open]);

  return (
    <Dialog open={open} maxWidth="xs" PaperProps={{ style: { width: '339px', height: '85px' } }} id="reading">
      <DialogContent style={{ padding: '15px 20px' }}>
        <LinearProgress variant="determinate" value={progress} style={{ marginBottom: '10px', marginTop: '10px', width: '100%' }} />
        <Typography className='!font-jost' align="center" variant="subtitle1">Deleting Account...</Typography>
      </DialogContent>
    </Dialog>
  );
}

export default LoadingPopup;
